import HttpClient from '../../adapter/HttpClient';

class AuthenticationWebApi {
  private httpClient: HttpClient;

  constructor({ httpClient }: { httpClient: HttpClient }) {
    this.httpClient = httpClient;
  }

  public signIn = async ({ email, password }: { email: string; password: string }): Promise<void> => {
    await this.httpClient.post('/authentication_token', {
      email,
      password,
    });
  };

  public signInWithOtp = async ({ otp }: { otp: string }): Promise<void> => {
    await this.httpClient.post('/authentication_token/otp', {
      otp_code: otp,
    });
  };

  public recoverOtp = async ({ otpRecoveryCode }: { otpRecoveryCode: string }): Promise<void> => {
    await this.httpClient.post('/authentication_token/otp', {
      otp_recovery_code: otpRecoveryCode,
    });
  };

  public requestPasswordReset = async (email: string): Promise<void> => {
    await this.httpClient.post('/password_resets', {
      user: {
        email,
      },
    });
  };

  public resetPassword = async (token: string, newPassword: string): Promise<void> => {
    await this.httpClient.put(`/password_resets/${token}`, {
      user: {
        password: newPassword,
      },
    });
  };

  public signUp = async ({
    email,
    username,
    password,
    // recaptcha,
    lang,
    invitation,
    via,
  }: {
    email?: string;
    username: string;
    password: string;
    // recaptcha?: string;
    lang: string;
    invitation?: string;
    via: string | null;
  }): Promise<void> => {
    await this.httpClient.post('/registrations', {
      email,
      username,
      password,
      lang,
      invitation_code: invitation,
      // g_recaptcha_response: recaptcha,
      via,
    });
  };

  public oauthAgreement = async (via: string | null): Promise<void> => {
    await this.httpClient.post(`/oauth/agreement`, { via });
  };

  public signOut = async (): Promise<void> => {
    await this.httpClient.delete(`/authentication_token`, {});
  };
}

export default AuthenticationWebApi;
